<template>
  <div>
    <clients-list
      :items="elements"
      :search="search"
      :can-add-clients="canAddCustomers"
      :count="count"
      :loading="loading"
      :tabs="tabs"
      @onSearch="onSearch"
      @tabChanged="onTabChange"
      @addClient="onAddClient"
      @cellClicked="cellClicked"
      @load-more="loadMore"
    >
      <template v-slot:breadcrumb>
        <base-breadcrumb
          :routes="routes"
          class="my-0 pb-1"
        />
      </template>
      <template v-slot:title>
        <div v-if="loading">
          <base-skeleton>
            <div
              class="skeleton__item"
              style="width: 140px;"
            />
          </base-skeleton>
        </div>
        <div v-else>
          {{ profile.user.first_name }} {{ profile.user.last_name }}'s Clients
        </div>
      </template>
    </clients-list>
  </div>
</template>
<script>

import ClientsList from '@/components/Widgets/ClientsList';
import { EventBus } from '@/event-bus';
import _ from 'lodash';

export default {
  name: 'ManageClientsContainer',
  components: {
    ClientsList,
  },
  data() {
    return {
      search: '',
      nextPageExists: true,
      truePage: 0,
      pageSize: 10,
      tabs: ['Clients', 'Groups'],
    };
  },
  computed: {
    /* loading() {
      return this.$store.state.profiles.status === 'FETCHING';
    }, */
    profile() {
      if (!this.$store.state.profiles.item) {
        return {
          user: {
            first_name: '',
            last_name: '',
          },
          pk: '',
        };
      }
      return this.$store.state.profiles.item;
    },
    elements() {
      if (!this.profile) {
        return [];
      }
      return this.$store.state.customers.items;
    },
    count() {
      if (!this.elements.length) {
        return 0;
      }
      return this.$store.state.customers.count;
    },
    canAddCustomers() {
      return this.useFeature('add_customers');
    },
    team() {
      if (!this.profile) {
        return null;
      }
      return this.profile.team;
    },
    loading() {
      return this.$store.state.profiles.itemStatsLoading || !this.profile?.pk;
    },
    routes() {
      return [
        {
          name: 'Dashboard',
          link: '/dashboard',
        },
        {
          name: `${this.profile.user.first_name} ${this.profile.user.last_name}`,
          link: `/user/${this.profile.pk}`,
          loading: this.loading,
        },
        {
          name: 'Manage Clients',
        },
      ];
    },
  },
  watch: {
    team(newval) {
      if (newval.pk) {
        this.truePage += 1;
      }
    },
    search(newval) {
      this.truePage = 1;
      this.reset();
      this.fetchData();
    },
    truePage() {
      this.fetchData();
    },
  },
  beforeMount() {
    this.reset();
  },
  mounted() {
    this.truePage = 1;
    this.nextPageExists = true;
    this.$store.dispatch('profiles/fetchItem', this.$route.params.id);
    this.fetchData();
  },
  methods: {
    // eslint-disable-next-line func-names
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    onAddClient() {
      EventBus.$emit('open-add-client-modal');
    },
    loadMore() {
      if (this.nextPageExists && !this.loading) {
        this.truePage += 1;
      }
    },
    fetchData() {
      const kwargs = {
        page: this.truePage,
        page_size: this.pageSize,
        assigned_to: this.profile.pk,
        search: this.search,
        scope: this.$store.getters['account/scope'],
      };
      this.$store.dispatch('customers/addPage', kwargs).then((response) => {
        if (response && response.data) {
          this.nextPageExists = response.data.next != null;
        }
      }).catch((error) => {
        if (error.response.status === 404) {
          // Page doesn't exist
        }
      });
    },
    cellClicked(customer) {
      this.$router.push(`/admin/clients/${customer.pk}`);
      if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
        this.$mixpanel.track('Manage_Clients', {
          account_id: this.$store.state.account.user.user.email,
          client: customer.pk,
        });
      }
    },
    reset() {
      this.$store.dispatch('customers/reset');
    },
    onTabChange(evt) {
      if (evt === 1) {
        this.$router.push('manage-groups');
      } else {
        this.$router.push('manage-clients');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
